module.exports = __webpack_public_path__ + "static/img/platform_advantages4.51ac062.png";


//////////////////
// WEBPACK FOOTER
// ./static/images2/platform_advantages4.png
// module id = AtZR
// module chunks = 2